import React from "react";
import { LoadingButton } from "@atlaskit/button";
import CrossIcon from "@atlaskit/icon/glyph/cross";
import AbortWargameMutation from "../../graphql/abort-wargame.mutation.graphql";
import { useMutationUI } from "../../hooks";
export var AbortWargameButton = function (_a) {
    var id = _a.id;
    var _b = useMutationUI({
        mutation: AbortWargameMutation,
        options: {
            variables: {
                id: id
            }
        },
        successMessage: "Wargame will be aborted in a few seconds"
    }), isLoading = _b.isLoading, mutate = _b.mutate;
    return (React.createElement(LoadingButton, { iconBefore: React.createElement(CrossIcon, { label: "abort", size: "small" }), appearance: "danger", onClick: function () { return mutate(); }, isLoading: isLoading }, "Abort"));
};
